import { InferType } from 'yup';
import { formValuesSchema as baseSchema } from '../HealthPolicyClaim/schema';

export const formValuesSchema = baseSchema;

export type FormValues = InferType<typeof formValuesSchema>;
